<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <FlowProfessionalTypeTree height="85vh" @nodeClick="nodeClick" />
    </div>
    <div class="d-flex-right">
      <div class="search-wrap">
        <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
      </div>

      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
          <el-table-column prop="id" label="id" align="center"></el-table-column>
          <el-table-column prop="name" label="名称" align="center" width="240"></el-table-column>
          <el-table-column prop="method" label="处理方式" align="center" width="100"></el-table-column>
          <el-table-column prop="url" label="地址" align="center" width="240">
            <template slot-scope="scope">
              <div style="width: 230px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{scope.row.url}}</div>
            </template>
          </el-table-column>
<!--          <el-table-column prop="form_data" label="名称" align="center" width="240"></el-table-column>-->
          <el-table-column prop="status" label="状态" align="center" width="180">
            <template slot-scope="scope">
              {{scope.row.status?'显示':'隐藏'}}
            </template>
          </el-table-column>

          <el-table-column prop="create_time" label="创建时间" align="center" width="180"></el-table-column>
          <el-table-column prop="update_time" label="修改时间" align="center" width="180"></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteCmsChannel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="业务名称" prop="title">
            <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="业务类型" prop="title">
            <el-select size="mini" v-model="form.type_id" filterable placeholder="请选择">
              <el-option
                v-for="item in flow_professional_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理方式" prop="title">
            <el-select size="mini" v-model="form.method" filterable placeholder="请选择">
              <el-option
                v-for="item in ['post','get']"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="请求地址" prop="title">
            <el-input class="form-input" v-model="form.url" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="请求参数" prop="title">
            <el-input type="textarea" placeholder="placeholder" v-model="form.form_data"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="title">
            <el-radio v-model="form.status" label="1">显示</el-radio>
            <el-radio v-model="form.status" label="0">隐藏</el-radio>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// {$房产}
import Http from "./common/Http";
import UploadFilesSysc from "./components/UploadFilesSysc";
import UploadFileSysc from "./components/UploadFileSysc";
import FlowProfessionalTypeTree from "./components/FlowProfessionalTypeTree";

export default {
  name:"FlowProfessionalType",
  components: {FlowProfessionalTypeTree, UploadFileSysc, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        type_id:"",
        url:"",
        method:"post",
        form_data:"",
        status:"",
      },
      uploadUrl:"",
      flow_professional_type_list:[],
    }
  },
  created() {
    this.host_url=Http.getBaseURL();
    this.uploadUrl=this.host_url+"flow/FlowType/uploadFile";
    this.getParentList();
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        type_id:"",
        url:"",
        method:"post",
        form_data:"",
        status:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getParentList() {
      const that = this;
      let where={};
      Http.get("flow/FlowProfessionalType/getList",{
        where:JSON.stringify(where),
        field:"id,name",
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.flow_professional_type_list=res.data.list.map(ret=>{
            ret.status=!!ret.status;
            return ret;
          })
        }
      })
    },
    getList() {
      const that = this;
      that.loading=true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      Http.get("flow/FlowProfessionalWork/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          res.data.list=res.data.list.map(ret=>{
            ret.status=!!ret.status;
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {
      if(!item) {
        this.form = this.getFormData({})
      } else {
        this.form = item
      }
      this.dialogVisible = true
    },

    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          data.status=data.status?1:0;
          Http.post("flow/FlowProfessionalWork/save",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.getList()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      const that = this;
      data.status=data.status?1:0;
      Http.post("flow/FlowProfessionalWork/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    onAreaChange({data,pathData,ids}){
      this.form.province_city=data.mergename;
      this.form.province_city_ids=ids.join(',')
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    deleteCmsChannel(item){
      const that = this;
      Http.post("flow/FlowProfessionalWork/delete", {id:item.id},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    nodeClick(e){
      this.where.type_id=e.id;
      this.type_name=e.name;
      this.pageData.page = 1
      this.getList();
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
  display: flex;
  flex-direction: row;
  //justify-content: space-between;
}

.table-wrap {
  margin-top: 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: flex-start;
  justify-content: flex-start;

  .table-wrap-item{
    margin: 10px 0;
    width: 250px;
    margin-left: 20px;
    cursor: pointer;
    height: 50px;

    .el-card-item{
      padding: 15px;
    }
  }
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowProfessionalWork.vue